
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import ClientLearn from "../ClientLearn";

interface KnowledgeHubViewProps {
  onBack: () => void;
}

const KnowledgeHubView = ({ onBack }: KnowledgeHubViewProps) => {
  return (
    <div className="relative">
      {/* Embed the existing ClientLearn component with back handler */}
      <ClientLearn onBack={onBack} />
    </div>
  );
};

export default KnowledgeHubView;
